import React from 'react';
import MaintenancePage from './components/MaintenancePage';

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const MaintenanceWrapper: React.FC<MaintenanceWrapperProps> = ({ children }) => {
  // Check if maintenance mode is enabled
  const isMaintenanceMode = () => {
    // Check if APP_CONFIG exists on window (production)
    if (typeof window !== 'undefined' && window.APP_CONFIG) {
      return window.APP_CONFIG?.maintenancePageEnabled;
    }
    
    // Fallback to process.env for development
    return process.env.REACT_APP_MAINTENANCE_PAGE_ENABLED === 'true';
  };

  const getMaintenanceMessage = () => {
    // Check if APP_CONFIG exists on window (production)
    if (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG.maintenanceMessage) {
      return window.APP_CONFIG?.maintenanceMessage;
    }
    
    // Fallback to process.env for development, with default maintenance message
    return 'This site is currently down for maintenance.';
  };

  // If maintenance mode is enabled, show maintenance page
  if (isMaintenanceMode()) {
    return <MaintenancePage message={getMaintenanceMessage()} />;
  }

  // Otherwise, render the normal app
  return <>{children}</>;
};

export default MaintenanceWrapper;